module.exports = __webpack_public_path__ + "static/img/2.e3eab3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/2.png
// module id = Bndk
// module chunks = 0